import * as React from 'react'

function IconRhombusCanJoin({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={104}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g
            filter="url(#filter1_rhombus)"
            strokeMiterlimit={10}
            strokeLinecap="round"
          >
            <path
              d="M45.248 102L2 58.75c3.73-3.73 3.73-9.777 0-13.504L45.248 2c3.73 3.73 9.778 3.73 13.504 0L102 45.246c-3.73 3.73-3.73 9.778 0 13.504L58.756 102a9.552 9.552 0 00-13.508 0z"
              fill="#fff"
              stroke={color}
              strokeWidth={2}
            />
            <path
              d="M9.865 57.914A16.44 16.44 0 0010.955 52a16.44 16.44 0 00-1.09-5.914l36.046-36.7a15.643 15.643 0 005.808 1.11c2.02 0 3.983-.381 5.809-1.11l36.045 36.7A16.44 16.44 0 0092.483 52c0 2.057.375 4.055 1.09 5.914l-36.045 36.7a15.643 15.643 0 00-5.809-1.11c-2.02 0-3.982.381-5.808 1.11l-36.046-36.7z"
              fill={color}
              stroke="#fff"
            />
          </g>
          <defs>
            <filter
              id="filter1_rhombus"
              x={0.585449}
              y={0.585449}
              width={102.829}
              height={102.829}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M45.248 102L2 58.75c3.73-3.73 3.73-9.777 0-13.504L45.248 2c3.73 3.73 9.778 3.73 13.504 0L102 45.246c-3.73 3.73-3.73 9.778 0 13.504L58.756 102a9.552 9.552 0 00-13.508 0z"
            fill="#fff"
            stroke={color}
            strokeWidth={2}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M9.865 57.914A16.44 16.44 0 0010.955 52a16.44 16.44 0 00-1.09-5.914l36.046-36.7a15.641 15.641 0 005.808 1.11c2.02 0 3.983-.381 5.809-1.11l36.045 36.7A16.44 16.44 0 0092.483 52c0 2.057.375 4.055 1.09 5.914l-36.045 36.7a15.643 15.643 0 00-5.809-1.11c-2.02 0-3.982.381-5.808 1.11l-36.046-36.7z"
            fill="#fff"
            stroke={color}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconRhombusCanJoin
